<div class="form-alert__info" (click)="fnOpenPolicyViolationPanel()">
  <div class="text__icon">
      <img class="icons" [src]="ICONS.ALERT_TRIANGLE" alt="" />
      <p class="alert-text">{{ 'click_to_view_policy_violation' | translate }}</p>
  </div>
  <img class="chevrons" [src]="ICONS.CHEVRON_RIGHT" alt="" />
</div>

@if(showPolicyViolationPanel){<policy-violation-panel [inputData]="policyViolationInputModel"
  [isReceiptNumberSettingsEnabled]="isReceiptNumberSettingsEnabled"
  (closePanelEvent)="fnClosePolicyViolationPanel($event)" [zindex_Class]="zindexClass"></policy-violation-panel>}